import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Resultados',
  subtitle: 'Números agregados por campanha. Recortes com menos de 20 pessoas aparecem sem número.',
  period: 'Período',
  lastDays: {
    one: 'Último dia',
    other: 'Últimos {{count}} dias',
  },
  loadError: 'Não foi possível carregar as campanhas',
  reportError: 'Não foi possível carregar os números da campanha',
  bySlot: 'Por lugar no app',
  slotColumn: 'Lugar',
  byVariant: 'Por variante',
  variantColumn: 'Variante',
} satisfies TranslationTree;
